import {createNode} from "./common/ui";

(function () {
	function initUi() {
		const shopCountriesRadios = document.querySelectorAll('.countries__country-radio');
		const shopId = document.querySelector('[data-shop-id]').getAttribute('data-shop-id');
		const shopPicture = document.querySelector('.sys__shop-picture');
		const shopNavLinks = document.querySelectorAll('.sys__shop-nav-link');
		const shopLink = document.querySelector('.sys__shop-link');
		const shopBadge = document.querySelector('.sys__shop-badge');
		const shopDescription = document.querySelector('.sys__shop-description');
		const shopGoods = document.querySelector('.sys__shop-goods');
		const shopCategoriesContainer = document.querySelector('.sys__shop-categories-container');
		const shopCategories = document.querySelector('.sys__shop-categories');

		let loadShopsHandler;
		let loadCategoriesHandler;

		function getRelatedRadioButton(targetRadioButton) {
			return [...shopCountriesRadios]
				.find(radioButton => radioButton !== targetRadioButton && radioButton.value === targetRadioButton.value);
		}

		function updateShopData(shop, categories, isoCode) {

			shopNavLinks.forEach(shopNavLink => {
				shopNavLink.href = shop[`link${isoCode}`];
				shopNavLink.innerHTML = !!shop[`vpn${isoCode}`] 
					? 'В магазин <span class="shop__badge" title="Для доступа в магазин понадобится VPN">VPN</span>'
					: 'В магазин'
			})
			shopLink.href = shop[`link${isoCode}`];
			shopLink.innerHTML = shop[`link${isoCode}`];
			if (!!shopBadge) {
				shopBadge.style.display = !!shop[`vpn${isoCode}`] ? 'block' : 'none';
			}
			shopDescription.innerHTML = shop[`detailedDescription${isoCode}`]
			const shopPictureSource = createNode('source', undefined, {
				srcset: `/images/webp/shops/detailed/${isoCode}/${shop.logoWebp}, /images/webp/shops/detailed/${isoCode}/${shop.logoWebp2x} 2x, /images/webp/shops/detailed/${isoCode}/${shop.logoWebp3x} 3x`,
				type: 'image/webp'
			});
			const shopPictureImg = createNode('img', 'shop__screenshot', {
				src: `/images/shops/detailed/${isoCode}/${shop.logo}`,
				srcset: `/images/shops/detailed/${isoCode}/${shop.logo}, /images/shops/detailed/${isoCode}/${shop.logo2x} 2x, /images/shops/detailed/${isoCode}/${shop.logo3x} 3x`,
				width: 680,
				height: 440,
				alt: shop.name
			});
			shopPicture.innerHTML = '';
			shopPicture.appendChild(shopPictureSource);
			shopPicture.appendChild(shopPictureImg);
			if (!!shopGoods) {
				shopGoods.style.display = (isoCode === 'US' ? 'block' : 'none');
			}

			shopCategoriesContainer.style.display = categories.length === 0 ? 'none' : 'flex';
			shopCategories.innerHTML = '';
			
			categories.forEach(category => {
				const li = createNode('li');
				const link = createNode('a', 'shop__category', {
					href: `/shops/${category.id}.html`,
					innerText: category.name,
				})
				li.appendChild(link);
				shopCategories.appendChild(li);
			})
		}

		function loadData(isoCode) {
			return new Promise(resolve => {
				const promises = [loadShopsHandler(), loadCategoriesHandler(isoCode)];

				Promise.all(promises).then(response => {
					resolve({
						shops: response[0],
						categories: response[1]
					})
				});
			})
		}

		return {
			onCountryClick: function (newLoadShopsHandler, newLoadCategoriesHandler) {
				loadShopsHandler = newLoadShopsHandler;
				loadCategoriesHandler = newLoadCategoriesHandler;

				for (let countryRadio of shopCountriesRadios) {
					countryRadio.addEventListener('change', function () {
						loadData(countryRadio.value)
							.then(response => {
								const shop = response.shops.find(data => data.id === shopId);
								const categories = response.categories.filter(category => category.shops.includes(shop.id));
								updateShopData(shop, categories, countryRadio.value);
							});

						getRelatedRadioButton(countryRadio).checked = countryRadio.checked;
					});
				}
			},
		};
	}

	function initApi() {
		const random = Math.floor(Math.random() * 10000000000000000);
		return {
			fetchShops: function () {
				return new Promise((resolve, reject) => {
					fetch(`/get/shops.json?${random}`)
						.then(response => {
							response.json().then((data) => {
								resolve(data);
							})
						})
						.catch(reject)
				})
			},
			fetchCategories: function (isoCode) {
				return new Promise((resolve, reject) => {
					fetch(`/get/${isoCode}/shopsCategories.json?${random}`)
						.then(response => {
							response.json().then((data) => {
								resolve(data);
							})
						})
						.catch(reject)
				})
			}
		};
	}

	function initBehaviour(ui, api) {
		const loadShopsHandler = () => api.fetchShops();
		const loadCategoriesHandler = (countryIsoCode) => api.fetchCategories(countryIsoCode);

		ui.onCountryClick(loadShopsHandler, loadCategoriesHandler)
	}

	document.addEventListener('DOMContentLoaded', function () {
		const ui = initUi();
		const api = initApi();
		initBehaviour(ui, api);
	});
})();
